module.exports = __webpack_public_path__ + "img/qualification_5.c54e29ab.png";